export function getUiComponentName(strapiComponentName: string | undefined, componentNames?: Record<string, string>) {
  if (!strapiComponentName) {
    return ''
  }

  if (componentNames?.[strapiComponentName]) {
    return componentNames[strapiComponentName]
  }

  if (strapiComponentName.startsWith('Component')) {
    return strapiComponentName.substring('Component'.length)
  }

  return strapiComponentName
}
